export { AddDashesPipe } from './add-dashes.pipe';
export { CapitalizePipe } from './capitalize.pipe';
export { AgreementPipe } from './agreement.pipe';
export { ServiceDeskComponent } from './servicedesk.component';
export { ServiceDeskService } from './servicedesk.service';


